import { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import { useFormContext } from 'framework/form';
import { PROCESS_ASSETS_CTO, PROCESS_ASSETS_STATUS } from 'domain/gpo/processAssets/constants';
import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';
import { useAuthorization } from 'framework/authorization';
import { ProcessAssetsFormType } from 'domain/gpo/processAssets/types';
import { useAsyncValue } from 'framework/utils';

const ViewProcessAssetModalActions = ({ onCloseModal }: { onCloseModal: () => void }) => {
  const { isGranted } = useAuthorization();
  const { isSubmitEnabled, isLoadingArtifact, submitForm, onChangeCallback } = useFormContext();
  const [submitting, setSubmitting] = useState(false);
  const { getUserAlias } = useAuthenticatedUserService();
  const currentUserAlias = useAsyncValue(async () => getUserAlias());

  const { data: formData } = useFormContext();
  const { status, owner } = (formData || {}) as ProcessAssetsFormType;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const initStatus = useMemo(() => status, []);
  const accessPublishActions = isGranted([PROCESS_ASSETS_CTO]) || owner === currentUserAlias;

  useEffect(() => {
    if (submitting && submitForm) {
      submitForm();
      setSubmitting(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitting]);

  const publishMethod = async (newStatus: string) => {
    if (onChangeCallback) {
      onChangeCallback({ status: newStatus });
      setSubmitting(true);
    }
  };

  const renderPublishActions = () => {
    if (!accessPublishActions) {
      return null;
    }

    return initStatus !== PROCESS_ASSETS_STATUS.PUBLISHED ? (
      <Button
        color="secondary"
        onClick={() => publishMethod(PROCESS_ASSETS_STATUS.PUBLISHED)}
        disabled={!isSubmitEnabled || isLoadingArtifact}
      >
        Publish
      </Button>
    ) : (
      <Button
        data-testid="submit-button"
        onClick={() => publishMethod(PROCESS_ASSETS_STATUS.UNPUBLISHED)}
        disabled={!isSubmitEnabled || isLoadingArtifact}
        variant="outlined"
      >
        Unpublish
      </Button>
    );
  };

  return (
    <Box display="flex" gap="10px">
      {renderPublishActions()}

      <Button data-testid="cancel-btn" variant="outlined" type="button" onClick={onCloseModal}>
        Cancel
      </Button>
    </Box>
  );
};

export default ViewProcessAssetModalActions;
